<template>
  <div class="TeamLeader">
    <Block404 v-if="show404" />
    <template v-else>
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{path: '/'}">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{path: '/team'}">机构信息</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="news">
        <div class="title">领导信息</div>
        <div class="block">
          <div class="right">
            <div class="content">
              <img :src="require('@/assets/images/team_leader_'+id+'.png')" />
              <div class="info">
                <div class="name">{{data.name}}</div>
                <div class="text">{{data.desc}}</div>
              </div>
            </div>
          </div>
          <div class="left">
            <div class="label">
              <div>领导信息</div>
            </div>
            <div class="content">
              <div
                v-for="(item, index) in leader"
                :key="index"
                class="item"
                @click="goLeader(item)"
              >{{item.name}}</div>
            </div>
          </div>
        </div>
        <div class="only_pc">
          <div class="tools">
            <div class="tools_item" @click="savePage">保存本页</div>
            <div class="tools_item" @click="printPage">打印本页</div>
            <div class="tools_item" @click="closePage">关闭窗口</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import Block404 from "@/components/Block404.vue";
import teamData from "@/utils/teamData";

export default {
  name: "TeamLeader",
  components: {
    Block404
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      id: this.$route.params.id,
      show404: false,
      leader: [],
      data: {}
    };
  },
  watch: {
    $route(to) {
      if (to.params.id && to.params.id != this.id) {
        this.id = to.params.id;
        this.show404 = false;
        this.loadData();
      }
    }
  },
  methods: {
    loadData() {
      document.documentElement.scrollTop = 0;
      let current = null;
      teamData.leader.forEach(item => {
        if (item.id == this.id) current = item;
      });
      if (current) {
        this.leader = teamData.leader;
        this.data = current;
      } else {
        this.show404 = true;
      }
    },
    goLeader(item) {
      this.$router.push({
        path: "/team/leader/" + item.id
      });
    },
    savePage() {
      let data = document.getElementsByTagName("html")[0].outerHTML,
        urlObject = window.URL || window.webkitURL || window,
        exportBlob = new Blob([data]),
        saveLink = document.createElementNS(
          "http://www.w3.org/1999/xhtml",
          "a"
        ),
        ev = document.createEvent("MouseEvents");
      saveLink.href = urlObject.createObjectURL(exportBlob);
      saveLink.download = "news" + this.id + ".html";
      ev.initMouseEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      saveLink.dispatchEvent(ev);
    },
    printPage() {
      window.print();
    },
    closePage() {
      window.close();
    }
  }
};
</script>
<style lang="scss" scoped>
.TeamLeader {
  padding-top: 40px;
  padding-bottom: 60px;
  @include body_block;
  @media (max-width: $mob-screen) {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .breadcrumb {
    margin-bottom: 20px;
    @media (max-width: $mob-screen) {
      margin-bottom: 8px;
    }
    @media print {
      display: none;
    }
    .el-breadcrumb {
      line-height: 28px;
      font-size: 20px;
      @media (max-width: $mob-screen) {
        line-height: 20px;
        font-size: 14px;
      }
    }
  }
  .news {
    background: #fff;
    padding: 48px 65px;
    @media (max-width: 900px) {
      padding: 48px 50px;
    }
    @media (max-width: $mob-screen) {
      padding: 16px;
    }
    .title {
      line-height: 50px;
      font-size: 36px;
      font-weight: 600;
      text-align: center;
      color: $primary_blue;
      @media (max-width: $mob-screen) {
        line-height: 30px;
        font-size: 18px;
      }
    }
    .block {
      margin-top: 42px;
      @include flex_between_start;
      flex-direction: row-reverse;
      @media (max-width: $mob-screen) {
        margin-top: 20px;
        display: block;
      }
      .label {
        border-bottom: 1px solid rgba(22, 49, 112, 0.2);
        margin-bottom: 30px;
        @include flex_start_start;
        @media (max-width: $mob-screen) {
          margin-bottom: 14px;
        }
        div {
          width: 139px;
          height: 40px;
          box-sizing: border-box;
          padding-left: 17px;
          padding-top: 3px;
          line-height: 26px;
          font-size: 18px;
          color: #fff;
          @include pic_bg_cover;
          background-image: url(../assets/images/team_leader_label.png);
        }
      }
      .right {
        flex-grow: 1;
        .content {
          @include flex_between_start;
          @media (max-width: $mob-screen) {
            display: block;
          }
          img {
            flex-shrink: 0;
            display: block;
            width: 216px;
            margin-right: 34px;
            @media (max-width: 770px) {
              width: 160px;
              margin-right: 14px;
            }
            @media (max-width: $mob-screen) {
              max-width: 100%;
              margin-right: 0;
            }
          }
          .info {
            flex-grow: 1;
            padding-top: 5px;
            color: #242424;
            .name {
              line-height: 41px;
              font-size: 28px;
              font-weight: bold;
              @media (max-width: $mob-screen) {
                margin-top: 14px;
                line-height: 20px;
                font-size: 18px;
              }
            }
            .text {
              margin-top: 25px;
              line-height: 28px;
              font-size: 18px;
              @media (max-width: $mob-screen) {
                margin-top: 14px;
                line-height: 20px;
                font-size: 14px;
              }
            }
          }
        }
      }
      .left {
        flex-shrink: 0;
        width: 220px;
        margin-right: 110px;
        @media (max-width: 950px) {
          width: 160px;
          margin-right: 40px;
        }
        @media (max-width: $mob-screen) {
          width: 100%;
          margin-top: 20px;
          margin-right: 0;
        }
        .content {
          .item {
            margin-top: 12px;
            padding: 6px;
            background: #eaedf4;
            border-radius: 2px;
            line-height: 26px;
            font-size: 18px;
            color: #242424;
            font-weight: 500;
            cursor: pointer;
            @include flex_center_center;
            @media (max-width: $mob-screen) {
              line-height: 20px;
              font-size: 14px;
            }
            &:first-child {
              margin-top: 0;
            }
          }
        }
      }
    }
    .tools {
      margin-top: 40px;
      @include flex_center_center;
      .tools_item {
        width: 155px;
        line-height: 49px;
        background: #f5f6f9;
        text-align: center;
        margin: 0 20px;
        font-size: 16px;
        color: #000;
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="scss">
@for $i from 2 to 6 {
  .page_theme_#{$i} {
    .TeamLeader {
      .news {
        background: nth($bg_color, $i);
        .title {
          color: nth($text_color, $i);
        }
        .block {
          .label {
            border-bottom-color: nth($text_color, $i);
            div {
              color: nth($text_color, $i);
              background-image: url();
            }
          }
          .left {
            .content {
              .item {
                background: nth($bg_color, $i);
                color: nth($text_color, $i);
                border: 1px solid nth($text_color, $i);
              }
            }
          }
          .right {
            .content {
              .info {
                color: nth($text_color, $i);
              }
            }
          }
        }
        .tools {
          .tools_item {
            background: nth($bg_color, $i);
            color: nth($text_color, $i);
            border: 1px solid nth($text_color, $i);
          }
        }
      }
    }
  }
}
</style>